import dayjs from "dayjs";
import duration from "dayjs/plugin/duration.js";
import type { ILocaleKeypath } from "~/composables/use-locale";

// eslint-disable-next-line import/no-named-as-default-member
dayjs.extend(duration);

type FriendlyTimeDurationProps = {
  minutes: number;
  translationConfig: {
    t: (
      key: ILocaleKeypath,
      params?: Record<string, string | number>,
    ) => string;
  };
};

export const friendlyTimeDuration = ({
  minutes: originalMinutes,
  translationConfig: { t },
}: FriendlyTimeDurationProps): string => {
  if (originalMinutes < 0) {
    throw new Error("Minutes cannot be negative");
  }

  const d = dayjs.duration(originalMinutes, "minutes");
  const hours = Math.floor(d.asHours());
  const minutes = d.minutes();

  if (hours > 0 && minutes > 0)
    return t("utils.duration.hoursAndMinutes", {
      hours: t("utils.duration.hour", { count: hours }),
      minutes: t("utils.duration.minute", { count: minutes }),
    });

  if (hours > 0) return t("utils.duration.hour", { count: hours });

  if (minutes > 0) return t("utils.duration.minute", { count: minutes });

  return t("utils.duration.minute", { count: 0 });
};
